import { put } from 'redux-saga/effects'
import importer from 'common/importer'
const { verifyEmail } = importer('APIs/users', null)
const UserActions = importer('Stores/Users/Actions')
export default function * main ({ recoveryToken, digitalId, sfid }) {
  try {
    yield put(UserActions.verifyEmailLoading())
    const res = yield verifyEmail(recoveryToken, digitalId, sfid)
    yield put(UserActions.verifyEmailSuccess(res))
  } catch (error) {
    yield put(UserActions.verifyEmailFailure(error.response.data))
  }
}
